import { Component } from '@angular/core';

@Component({
  selector: 'app-rpc',
  imports: [],
  templateUrl: './rpc.component.html',
  styleUrl: './rpc.component.scss',
})
export class RpcComponent {}
